export const blogData = [
    {
        "url": "https://edgardo-cj.medium.com/ebs-unused-volumes-9b11b0339d3b",
        "title": "EBS Unused Volumes",
        "date": "August 15th, 2022",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/ebs_unused_volume.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://edgardo-cj.medium.com/ebs-volume-tagging-c502dfc5c099",
        "title": "EBS Tagging",
        "date": "August 1st, 2022",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/ebs_volume.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://edgardo-cj.medium.com/aws-automation-eni-configuration-on-rhel-and-centos-f5ac9fc01901",
        "title": "ENI configuration on RHEL and CentOS",
        "date": "November 21st, 2021",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/blog-banner-6.jpg",
        "attribute": "Cloud"
    },
    {
        "url": "https://edgardo-cj.medium.com/aws-automation-ami-scheduling-62c6e037665a",
        "title": "AMI Scheduling",
        "date": "February 9th, 2021",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/blog-banner-5.jpg",
        "attribute": "Cloud"
    },
    {
        "url": "https://edgardo-cj.medium.com/aws-automation-ebs-volume-encryption-5e183102e8cd",
        "title": "EBS Volume Encryption",
        "date": "January 5th, 2021",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/background_used_for_ebs_encryption.jpg",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-ebs-volume-available-edgardo-reinoso/",
        "title": "EBS Volume Available",
        "date": "November 30th, 2020",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/process.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-ebs-volume-extension-edgardo-reinoso",
        "title": "EBS Volume Extend",
        "date": "September 30th, 2020",
        "image": "https://s3.amazonaws.com/personal-website-assets104410-dev/public/blog/background/2nd_iteration_sep_29_2020.jpg",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-iam-user-monitoring-part-2-edgardo-reinoso/",
        "title": "IAM user monitoring — Part 2",
        "date": "August 15th, 2020",
        "image": "https://s3.amazonaws.com/personal-website-assets104410-dev/public/blog/background/overhead-section-3.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-iam-user-monitoring-part-1-edgardo-reinoso/?trackingId=LGtGdIAWNzPnqNzZoE25yg%3D%3D",
        "title": "IAM user monitoring — Part 1",
        "date": "August 9th, 2020",
        "image": "https://s3.amazonaws.com/personal-website-assets104410-dev/public/blog/background/overhead-section-3.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-turn-offon-ec2-instances-onschedule-edgardo-reinoso/?trackingId=r8ZGCU0yHgVOLnAvEgfdGw%3D%3D",
        "title": "Turn off/on EC2 instances on schedule",
        "date": "July 15th, 2020",
        "image": "https://s3.amazonaws.com/personal-website-assets104410-dev/public/blog/background/ec2_turn_on_off.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-narrowing-security-grouprules-edgardo-reinoso",
        "title": "Narrowing security group rules",
        "date": "June 30th, 2020",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/security-group-rule.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-snapshots-copy-another-region-edgardo-reinoso/",
        "title": "Snapshots copy to another region",
        "date": "June 1st, 2020",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/snapshot_copy.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/aws-automation-assign-name-tags-network-interface-edgardo-reinoso/",
        "title": "Assign name tags to Network Interface",
        "date": "April 30th, 2020",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/automation_nic.png",
        "attribute": "Cloud"
    },
    {
        "url": "https://www.linkedin.com/pulse/trellops-get-more-done-less-time-edgardo-reinoso/",
        "title": "TrellOps: get more done in less time",
        "date": "August 15, 2019",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/trellops.png",
        "attribute": "Productivity"
    },
    {
        "url": "https://www.linkedin.com/pulse/how-i-landed-my-first-job-international-student-edgardo-reinoso/",
        "title": "How I landed my first job as an international student",
        "date": "June 27, 2018",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/landed_first_job.jpeg",
        "attribute": "Professional"
    },
    {
        "url": "https://www.linkedin.com/pulse/global-citizen-what-does-mean-edgardo-reinoso/",
        "title": "What is a Global Citizen?",
        "date": "February 18, 2018",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/global_citizen.jpeg",
        "attribute": "Professional"
    },
    {
        "url": "https://www.linkedin.com/pulse/you-really-entrepreneur-edgardo-reinoso/",
        "title": "Are you really an entrepreneur?",
        "date": "April 26, 2017",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/entrepreneur.jpeg",
        "attribute": "Professional"
    },
    {
        "url": "https://www.linkedin.com/pulse/what-like-interview-startup-edgardo-reinoso/",
        "title": "What is it like to interview for a Startup?",
        "date": "February 22, 2017",
        "image": "https://personal-website-assets104410-dev.s3.amazonaws.com/public/blog/background/startup_interview.jpeg",
        "attribute": "Professional"
    },
]

export default blogData